import { render, staticRenderFns } from "./index-seo-agency.vue?vue&type=template&id=54a96c2e&"
import script from "./index-seo-agency.vue?vue&type=script&lang=js&"
export * from "./index-seo-agency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports